import { ControlledCommandLine } from "#components/commmandLine/ControlledCommandLine";
import React from "react";
import { useAppDispatch, useAppSelector } from "#store";
import { ActionType, DatasourceEnum } from "#services/pilotService/types";
import { setQuery as setStoreQuery, setQuery } from "#store/ui";
import { push } from "redux-first-history";
import { generateUrl } from "#components/App/routing/generateUrl";
import { generatePath } from "react-router";
import { Routes } from "#/config";

export const Nl2SqlInput = ({ fullWidth }: { fullWidth?: boolean }) => {
    const storeQuery = useAppSelector(state => state.uiState.query);
    const dispatch = useAppDispatch();

    const [query, setQueryState] = React.useState(
        // "Find projects where Alberto Broggi was involved."
        storeQuery || ""
    );
    React.useEffect(() => {
        setQueryState(storeQuery);
    }, [storeQuery]);

    React.useEffect(() => {
        dispatch(setStoreQuery(query));
    }, [dispatch, query]);

    const datasourceDto = useAppSelector(
        state => state.uiState.selectedDatasource
    );
    const currentDatasource = datasourceDto.name;

    const currentOp = ActionType.NL2SQL;

    const onSubmit = (
        q: string = query,
        datasource: DatasourceEnum = currentDatasource,
        op: ActionType = currentOp
    ) => {
        dispatch(setQuery(q));
        dispatch(
            push(
                generateUrl(generatePath(Routes.triggerAction.path), {
                    q: q,
                    op: op,
                    o: datasourceDto.queryLanguage,
                    db: datasource,
                })
            )
        );
    };

    return (
        <ControlledCommandLine
            value={query}
            fullWidth={fullWidth}
            onChange={value => {
                setQueryState(value);
            }}
            error={false}
            onSubmit={v => onSubmit(query, currentDatasource, currentOp)}
        />
    );
};
